const TRACKED_FLAG = "sigma:device-tracked";

/**
 * Client-side device tracking after successful authentication.
 *
 * Runs at most once per browser session: the identity provider mounts in the
 * root layout, so without this guard every navigation cost a session read
 * plus a tracking POST. The server endpoint enforces the session itself, so
 * no separate session pre-check is needed here.
 */
export async function trackCurrentDevice() {
	try {
		if (sessionStorage.getItem(TRACKED_FLAG)) {
			return { success: true, skipped: true };
		}

		const response = await fetch("/api/user/devices/track", {
			method: "POST",
			credentials: "include",
		});

		if (response.status === 401) {
			return { success: false, error: "No active session" };
		}
		if (!response.ok) {
			throw new Error("Failed to track device");
		}

		sessionStorage.setItem(TRACKED_FLAG, "1");
		return await response.json();
	} catch (error) {
		console.error("Device tracking error:", error);
		return { success: false, error };
	}
}
